import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Shield } from 'lucide-react';
import PrivacyPolicyModal from './PrivacyPolicyModal';

const STORAGE_KEY = 'svb_cookie_accepted';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const timer = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0, y: 80 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 80 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            className="fixed left-3 right-3 z-[9970] flex justify-center svb-cookie-banner"
          >
            <div className="w-full max-w-4xl bg-gray-900/97 backdrop-blur-md border border-solana-primary/30 rounded-2xl p-4 md:p-5 shadow-2xl shadow-black/50 relative">

              {/* X — absolute top-right on all sizes */}
              <button
                onClick={accept}
                aria-label="Close cookie notice"
                className="absolute top-3 right-3 p-1.5 text-gray-400 hover:text-white transition-colors rounded-lg hover:bg-gray-800"
                style={{ WebkitTapHighlightColor: 'transparent' }}
              >
                <X className="w-4 h-4" />
              </button>

              {/* Row: Icon + Text */}
              <div className="flex items-start gap-3 pr-8 mb-3">
                <div className="w-9 h-9 bg-gradient-to-br from-solana-primary to-neon-cyan rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Shield className="w-4 h-4 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-white font-semibold text-sm mb-0.5">Cookie Notice</p>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    This website uses <strong className="text-white">only technically necessary cookies</strong> (session &amp; security). No tracking, no analytics, no marketing.{' '}
                    <button
                      onClick={() => setShowPrivacy(true)}
                      className="text-neon-cyan hover:underline focus:outline-none"
                      style={{ WebkitTapHighlightColor: 'transparent' }}
                    >
                      Privacy Policy
                    </button>
                  </p>
                </div>
              </div>

              {/* Accept button — full width on mobile, auto on desktop */}
              <button
                onClick={accept}
                className="w-full sm:w-auto sm:ml-12 block px-6 py-2.5 bg-gradient-to-r from-solana-primary to-neon-cyan text-white text-sm font-semibold rounded-xl text-center hover:scale-105 transition-transform"
                style={{ WebkitTapHighlightColor: 'transparent' }}
              >
                Accept &amp; Close
              </button>

            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <PrivacyPolicyModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} />
    </>
  );
};

export default CookieBanner;
